module.exports = {"451302001":"城东街道","451302002":"城北街道","451302003":"河西街道","451302005":"来华街道","451302101":"凤凰镇","451302102":"良江镇","451302103":"小平阳镇","451302104":"迁江镇","451302105":"石陵镇","451302106":"平阳镇","451302107":"蒙村镇","451302108":"大湾镇","451302109":"桥巩镇","451302110":"寺山镇","451302111":"城厢镇","451302112":"三五镇","451302113":"陶邓镇","451302114":"石牙镇","451302202":"五山乡","451302205":"良塘乡","451302206":"七洞乡","451302213":"南泗乡","451302214":"高安乡","451302216":"正龙乡","451302402":"来华投资区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451302.json
// module id = 2170
// module chunks = 0